<!--
   Created by qing on 2021/2/3
   Des: 
-->
<template>
  <div class="error-page" v-if="errorInfo">
    <img :src="`${$BASE_PATH}/fetch/image?id=376459314291802113.png`" alt="">
    <p>
      {{errorInfo.info}}({{errorInfo.code}})
    </p>
  </div>
  <div class="error-page" v-else>
    <img :src="`${$BASE_PATH}/fetch/image?id=376459314291802113.png`" alt="">
    <p>
      程序开小差啦，请稍后重试
    </p>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: true,
        errorInfo: null
      }
    },
    created() {
      this.errorInfo = JSON.parse(this.$route.query.info);
    },
    methods: {}
  }
</script>

<style lang="less">

  .error-page {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 300px;
      margin-top: 80px;
    }

    p {
      margin-top: 30px;
      color: #333333;
    }
  }
</style>